/**
 * Zod schema for relationship identification output.
 * Used with structured outputs to get guaranteed-valid JSON from the LLM.
 * Mirrors RawExtractedRelationship in llm-adapter.ts.
 */

import { z } from 'zod';

export const RelationshipSchema = z.object({
  sourceEntity: z.string().min(1),
  targetEntity: z.string().min(1),
  type: z.string().min(1),
  confidence: z.number().min(0).max(1),
  evidenceQuote: z.string().min(1),
});

export const RelationshipResultSchema = z.object({
  relationships: z.array(RelationshipSchema),
});
